export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'Home': 'Dashboard',
            'Report': 'Report',
            'Checkout': 'Checkout',
            'Labels': 'Labels',
            'Actions': 'Actions',
            'Inventory': 'Inventory Management',
            'SAMPLE': {
                'TITLE': 'Sample',
                'BADGE': '25'
            },
            'DASHBOARD': {
                'TITLE': 'DASHBOARD',
                'BADGE': '25'
            }
        }
    }
};
